import { Directive } from '@angular/core';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
  selector: '[hlmSelectValuesContent],hlm-select-values-content',
  exportAs: 'hlmSelectValuesContent',
})
export class HlmSelectValuesContent {
  constructor() {
    /* #region customizations */
    // Customization add min-w-0 and overflow-hidden, to avoid content overflow.
    classes(() => 'flex min-w-0 gap-2 overflow-hidden');
    /* #endregion customizations */
  }
}
